import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'

/**
 * Extension to prevent undoInputRule() command on backspace/delete key click
 * ref -
 *
 * https://github.com/ueberdosis/tiptap/blob/e8e4df38d5935f4bec5b8203446e0548fad57a77/packages/core/src/InputRule.ts#L159
 *
 * https://github.com/ueberdosis/tiptap/blob/e8e4df38d5935f4bec5b8203446e0548fad57a77/packages/core/src/InputRule.ts#L276
 *
 */
export const PreventInputRuleUndo = Extension.create({
  name: 'preventInputRuleUndo',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('preventInputRuleUndo'),
        filterTransaction: (transaction, state) => {
          // isInputRules spec is only added in InputRules plugin, So using this condition to identify
          // the plugin responsible for input rule, as the metadata for undoInputRule() command is stored
          // against this plugin as the key.
          const plugin = state.plugins.find((plugin) => plugin.spec.isInputRules)
          // We want to prevent undo of smartQuotes Input rule, so we are checking if straight quotes are
          // present in metadata being used for undoInputRule() command before clearing the metadata
          if (plugin && ["'", '"'].includes(transaction.getMeta(plugin)?.text)) {
            transaction.setMeta(plugin, {})
          }

          return true
        },
      }),
    ]
  },
})
